/**
 * @author: leroy
 * @date: 2021/8/28 14:37
 * @description：footer
 */

import styles from '@/styles/layout/footer.module.scss';
import Url from '@/utils/url';
import type { FC } from 'react';
import { handleUrl } from '@/utils/util';
import classNames from 'classnames';
import { useStore } from '@/store/store';

const Footer: FC<{ mode: API.Common.Mode; isCeping: boolean }> = ({ mode, isCeping = false }) => {
  const { homeStore } = useStore();
  const haveIcon = homeStore.examLogoConfig?.is_enterprise_logo;

  if (mode === 2) {
    return null;
  }
  return (
    <footer className={styles.footerBox}>
      <div className={classNames(styles.wrapper, { [styles.ceping]: isCeping })}>
        {!haveIcon && (
          <h1 className={styles.logoBox}>
            <img
              src={
                Url.staticHost +
                (isCeping ? '/image/home/ceping-logo-footer.png' : '/svg/footerLogo1.svg')
              }
              style={{ display: 'inline-block' }}
              height={'100%'}
              alt=""
            />
          </h1>
        )}
        {!haveIcon && (
          <div className={`center-wrapper ${styles.linkBox}`}>
            <a href={handleUrl(Url.wwwHost)} target="_blank" rel="noreferrer">
              校招
            </a>
            <a href={Url.wwwHost?.replace('www', 'xjh')} target="_blank" rel="noreferrer">
              宣讲会
            </a>
            <a href={Url.wwwHost?.replace('www', 'live')} target="_blank" rel="noreferrer">
              云宣讲
            </a>
            <a href={Url.wwwHost?.replace('www', 'sxh') + '/xzrl'} target="_blank" rel="noreferrer">
              校招日历
            </a>
            <a href={Url.wwwHost?.replace('www', 'mjfx')} target="_blank" rel="noreferrer">
              面经
            </a>
            <a href={Url.wwwHost?.replace('www', 'zycp')} target="_blank" rel="noreferrer">
              测评
            </a>
          </div>
        )}
        <div className={`center-wrapper ${styles.warnBox}`}>
          {!haveIcon && (
            <p>
              海投笔试网站所发布的笔试题目，由海投网注册用户提供题目，除非经特别声明，海投网不拥有该资料版权，亦不承担任何法律责任
            </p>
          )}
          <p>
            {/* © Copyright {new Date().getFullYear()}. 武汉鸣鸾信息科技有限公司{' '}
             <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
               鄂ICP备13001186号
             </a> */}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
